import type {
  DependencyValidationError,
  ParameterValueAmendOperation,
} from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { ParameterDetailsField } from '../types/parameterModel'
import type { ValidationErrorWithLocation } from '../uiModels/errors/types'
import type {
  IndexedParameterDefinitionCreateOperationWithMetaData,
  ParameterValueEntityOperation,
} from '../uiModels/parameterOperations/types'
import type { OperationWithSourceInfo } from '../uiModels/types'

type ParameterContextProps = {
  parameterDefinitionOperation: Optional<IndexedParameterDefinitionCreateOperationWithMetaData>
  parameterValueEntityOperationsForView: Optional<
    OperationWithSourceInfo<ParameterValueEntityOperation>[]
  >
  amendOperationsInView: OperationWithSourceInfo<ParameterValueAmendOperation>[]
  allParameterValueOperations: OperationWithSourceInfo<ParameterValueEntityOperation>[]
  parameterDefinitionErrors: ValidationErrorWithLocation<DependencyValidationError>[]
  parameterValueErrors: Map<
    string,
    ValidationErrorWithLocation<DependencyValidationError>[]
  >
  hasMoreValueOperations: boolean
  viewingDetails: Optional<ParameterDetailsField>
  detailsPath: Optional<string>
  reviewingOperation: Optional<
    OperationWithSourceInfo<ParameterValueEntityOperation>
  >
  onReviewOperation: (operationKey: Optional<string>) => void
}

const [useParameterContext, Provider] =
  createRequiredContext<ParameterContextProps>('ParameterContext')

export { Provider, useParameterContext }
